import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';

Swiper.use([Pagination, Navigation, Autoplay]);
import * as balanceText from 'Lib/balanceText.js';

export namespace RecipeSlider {
	let setupSlider = () => {

		let heroSliders = document.querySelectorAll('.js-recipe-slider');

		//For Each Hero Slider Loop through and setup swiper
		heroSliders.forEach((slider, index) => {
			slider.classList.add(`recipe-slider--${index}`);
			const swiper = new Swiper(`.recipe-slider--${index}`, {
				loop: true,
				autoplay: {
					delay: 7000,
				},

				// If we need pagination
				pagination: {
					el: `.recipe-slider--${index} .swiper-pagination`,
					clickable: true
				},


				on: {
					init: function () {
						balanceText();
					},
				}
			});
		});
	}


	export const init = () => {
		setupSlider();
	}
}


document.addEventListener('DOMContentLoaded', RecipeSlider.init);
